import Navbar from "./Navbar";
import { Grid, Toolbar, Box } from "@mui/material";
import whatsapplogo from "./resource/WhatsAppButtonGreenSmall.svg"
import backgroundClass from "./resource/musictheory3.jpg";
import Footer from "./Footer";
function Toapayoh(){
    const API_KEY="AIzaSyDaJaThFJ9mNxPhhvGEMMXGr3GDr0MEqdE"
    const backGroundBlur = {
        backgroundImage: `url(${backgroundClass})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      };
    return (
      <div style={backGroundBlur}>
        <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '20vh' }}
      >
        <Grid item lg={12} md={12} xs={12}>
          <Toolbar>
           <Navbar></Navbar>
          </Toolbar>
        </Grid>

        <Grid className="courses-section" container direction="column" justifyContent="center" textAlign="center">
        <Grid item> 
        <p style={{textAlign:"center", fontSize:"50px", color:"white"}}>Discover Your Musical Journey in the Heart of Toa Payoh! 💕</p>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="flex-start">
  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
    <Box sx={{ textAlign: 'center' }}>
      <p style={{ fontSize: "25px", margin: "0", color:"white" }}>
        Address 🏡: <br /> 36 Lor. 5 Toa Payoh, <br /> #11-341, <br /> Singapore 310036
      </p>
    </Box>
    <Box sx={{ textAlign: 'center' }}>
      <p style={{ fontSize: "25px", margin: "0", color:"white" }}>
        Telephone 📞: <br /> 8631 9188 <br /> Email: <br /> quindicesimasymphony@gmail.com

      </p>
    </Box>
    
  </Box>
</Grid>

<Grid container direction="row" justifyContent="center" alignItems="flex-start" sx={{ mt: 6 }}>
  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
    <Box sx={{ textAlign: 'center' }}>
      <p style={{ fontSize: "25px", margin: "0",color:"white"}}>
        Getting there by MRT 🚆: <br></br> Toa Payoh (NS19)
      </p>
    </Box>
    <Box sx={{ textAlign: 'center' }}>
      <p style={{ fontSize: "25px", margin: "0" ,color:"white"}}>
        Getting there by Bus 🚌: <br /> Take bus 231 or 235<br /> From Toa Payoh Interchange <br /> Alight at Lor 5 Toa Payoh - Blk 68 (52281)

      </p>
    </Box>
    
  </Box>
</Grid>
      
        <Grid item>
        <iframe
        height="450"
        style={{
          paddingTop:'20px',
          border: 0,
          maxWidth: '800px', // Limit the iframe width to 800px on larger screens
          width: '100%', // Make iframe width 100% of the parent container
          margin: '0 auto', // Center it horizontally
        }}  //Width=100% and maxWidth=800px works because for smaller screens you make the iframe occupy the 100% width of the parent container then for bigger screens
        //you limit the maxWidth to 800px so on larger screens where parent container will be wider and will be more than 800px, the iframe will not go beyond 800px
        //thus ensuring that the iframe will not be too big on larger screens
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${API_KEY}&q=Quindicesima Music Conservatory (school)`}
      />
        </Grid>

        </Grid>

        <Footer></Footer>
         <a
                    aria-label="Chat on WhatsApp"
                    href="https://wa.me/+6591124691?text=Hi%2C%20I%20am%20interested%20in%20the%20free%20trial%20lesson%20by%20Quindicesima%21"
                  >
                    {" "}
                    <img
                      alt="Chat on WhatsApp"
                      src={whatsapplogo}
                      style={{ position: "fixed", bottom: 5, right: 5 }}
                    />
                  </a>
</Grid>
</div>
)}

export default Toapayoh